// extracted by mini-css-extract-plugin
export default {"box":"orders_box__76Adc","cards":"orders_cards__GwnU4"};